import { useEffect, useState } from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import { NumericFormat, NumericFormatProps } from 'react-number-format';

interface NumberInputProps extends NumericFormatProps<TextFieldProps> {
  value: number | null;
  onchange: (value: number | null) => void
}

const NumberInput = ({value, onchange, ...rest}: NumberInputProps) => {
  const [input, setInput] = useState({
    textmask: '(100) 000-0000',
    numberformat: value || null,
  });

  useEffect(() => {
    onchange(input.numberformat)
  }, [input])

  const handleMinInvestAmtChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let inputvalue = event.target.value.split(',').join('')
    setInput({
      ...input,
      numberformat: inputvalue === '' ? null : Number(inputvalue),
    });
  };

  return (
    <NumericFormat
      value={value}
      onChange={handleMinInvestAmtChange}
      customInput={TextField}
      thousandSeparator
      valueIsNumericString
      {...rest}
    />
  );
};

export default NumberInput;